import {API} from "@/Composables/api";

const getStimuli = async (params = {}) => {
    return API.get(route("admin.stimuli.index"), params);
};

const getStimulus = async (id: number) => {
    return API.get(route("admin.stimuli.show", id));
};

const deleteStimulus = async (id: number) => {
    return API.delete(route("admin.stimuli.destroy", id));
};

export {getStimuli, getStimulus, deleteStimulus};
